<template>
  <!-- 客户流程详情 -->
  <div class="details-box">
    <div class="title">
      {{ TemplateID == 5 ? '重点客户审批进度' : '合作客户审批进度' }}（
      {{ details.Code }} ）
    </div>
    <div class="details-centent" v-if="JSON.stringify(details) != '{}'">
      <sub-title title="基本信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">企业名称：</div>
            <div class="item-right">
              {{ details['Name'] }}
            </div>
          </div>
          <div class="details-box-item" style="width: 66%">
            <div class="item-left">企业地址：</div>
            <div class="item-right">
              <span v-for="(item, i) in details.Addrs" :key="i">
                <span>{{ item.Address }}</span>
                <span v-if="!(i === details.Addrs.length - 1)"><br /></span>
              </span>
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">企业电话：</div>
            <div class="item-right">
              <span v-for="(item, i) in details.Tels" :key="i">
                <span>{{ item.Phone }}</span>
                <span v-if="!(i === details.Tels.length - 1)">、</span>
              </span>
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">企业法人：</div>
            <div class="item-right">
              {{ details.LegalPersonName }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">近一年主营收入：</div>
            <div class="item-right">
              <span
                v-if="
                  details.LatestYearIncomeTotal == 0 ||
                  details.LatestYearIncomeTotal
                "
                >{{ details.LatestYearIncomeTotal }} 元</span
              >
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">企业性质：</div>
            <div class="item-right">
              {{ details.Property }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">企业最高资质：</div>
            <div class="item-right">
              {{ details.HighestQualification }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">成立年份：</div>
            <div class="item-right">
              <span v-if="details.YearLimit == 0 || details.YearLimit"
                >{{ details.YearLimit }} 年</span
              >
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">注册资本：</div>
            <div class="item-right">
              <span
                v-if="
                  details.RegisteredCapitalAmount == 0 ||
                  details.RegisteredCapitalAmount
                "
                >{{ details.RegisteredCapitalAmount }} 万元</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">企业人员：</div>
            <div class="item-right">
              <span v-if="details.EmployeeTotal == 0 || details.EmployeeTotal"
                >{{ details.EmployeeTotal }} 人</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">资质总数量：</div>
            <div class="item-right">
              <span
                v-if="
                  details.ResouceQuantityTotal == 0 ||
                  details.ResouceQuantityTotal
                "
                >{{ details.ResouceQuantityTotal }} 个</span
              >
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">市级排名：</div>
            <div class="item-right">
              {{ details.CitySequence }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">历史中标数量：</div>
            <div class="item-right">
              <span
                v-if="
                  details.HistoryBidQuantity == 0 || details.HistoryBidQuantity
                "
                >{{ details.HistoryBidQuantity }} 个</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">历史荣誉：</div>
            <div class="item-right">
              <span
                v-if="
                  details.HistoryHonorQuantity == 0 ||
                  details.HistoryHonorQuantity
                "
                >{{ details.HistoryHonorQuantity }} 个</span
              >
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">分公司：</div>
            <div class="item-right">
              <span
                v-if="
                  details.BranchCompanyQuantity == 0 ||
                  details.BranchCompanyQuantity
                "
                >{{ details.BranchCompanyQuantity }} 个</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">主要项目区域：</div>
            <div class="item-right">
              {{ details.MainProjectRegion }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">是否新增：</div>
            <div class="item-right">
              {{ details.IsNewAdd == 'Y' ? '是' : '否' }}
            </div>
          </div>
        </div>
      </div>
      <sub-title title="企业资质"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">资质类型：</div>
            <div class="item-right">
              <span v-for="(item, i) in details.Qualification" :key="i">
                <span>{{ item }}</span>
                <span v-if="!(i === details.Qualification.length - 1)"
                  ><br
                /></span>
              </span>
            </div>
          </div>
          <div class="details-box-item" style="width: 66%">
            <div class="item-left">企业资质描述：</div>
            <div class="item-right">
              <span v-html="details.QualificationDesc"></span>
            </div>
          </div>
        </div>
      </div>
      <sub-title title="荣誉信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left setWidth1">最高荣誉级别：</div>
            <div class="item-right">
              {{ details.Honor }}
            </div>
          </div>
          <div class="details-box-item" style="width: 74%">
            <div class="item-left setWidth2">最高荣誉奖项名称：</div>
            <div class="item-right">
              <span v-for="(item, i) in details.HonorDesc" :key="i">
                <span>{{ item.Honor }}</span>
                <span v-if="!(i === details.HonorDesc.length - 1)"><br /></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <sub-title title="中标记录"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left setWidth3">
              最近一年公开中标记录项目数列（数量）：
            </div>
            <div class="item-right">
              <span
                v-if="
                  details.LatestYearBidProjectCount == 0 ||
                  details.LatestYearBidProjectCount
                "
                >{{ details.LatestYearBidProjectCount }} 个</span
              >
            </div>
          </div>
          <div class="details-box-item" style="width: 29%">
            <div class="item-left">总金额约合：</div>
            <div class="item-right">
              <span
                v-if="
                  details.LatestYearBidProjectAmount == 0 ||
                  details.LatestYearBidProjectAmount
                "
                >{{ details.LatestYearBidProjectAmount }} 万元</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left setWidth4">我司历史出函：</div>
            <div class="item-right">
              <span
                v-if="
                  details.HistoryDealOrderCount == 0 ||
                  details.HistoryDealOrderCount
                "
                >{{ details.HistoryDealOrderCount }} 笔数</span
              >
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left setWidth5">近一年在我司创收总计：</div>
            <div class="item-right">
              <span
                v-if="
                  details.LatestYearProfitAmountTotal == 0 ||
                  details.LatestYearProfitAmountTotal
                "
                >{{ details.LatestYearProfitAmountTotal }} 元</span
              >
            </div>
          </div>
          <div class="details-box-item" style="width: 29%">
            <div class="item-left">历史询单：</div>
            <div class="item-right">
              <span
                v-if="
                  details.HistoryConsultCount == 0 ||
                  details.HistoryConsultCount
                "
                >{{ details.HistoryConsultCount }} 笔数</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left setWidth4">中标分布区域主要集中在：</div>
            <div class="item-right">
              {{ details.LatestYearBidProjectRegion }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left setWidth6">
              近一年在我司出函项目渠道成本范围：
            </div>
            <div class="item-right">
              <span
                v-if="
                  details.LatestYearCostRange == 0 ||
                  details.LatestYearCostRange
                "
                >{{ details.LatestYearCostRange }} %</span
              >
            </div>
          </div>
          <div class="details-box-item" style="width: 74%">
            <div class="item-left setWidth2">中标记录：</div>
            <div class="item-right">
              <span
                v-for="(item, i) in details.LatestYearBidProjectDesc"
                :key="i"
              >
                <span>{{ item.Name }}</span>
                <span
                  v-if="!(i === details.LatestYearBidProjectDesc.length - 1)"
                  ><br
                /></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <sub-title title="其他信息"></sub-title>
      <div class="details-table" style="border: none">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left setWidth7">是否有竞争对手：</div>
            <div class="item-right">
              {{
                details.HasCompetitor === true
                  ? '是'
                  : details.HasCompetitor === false
                  ? '否'
                  : ''
              }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">竞争对手报价：</div>
            <div class="item-right">
              <span
                v-if="details.CompetitorPrice == 0 || details.CompetitorPrice"
                >{{ details.CompetitorPrice }} 元</span
              >
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">竞争对手名称：</div>
            <div class="item-right">
              {{ details.CompetitorName }}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">优化建议：</div>
            <div class="item-right">
              <span v-for="(item, i) in details.Suggest" :key="i">
                <span>{{ item }}</span>
                <span v-if="!(i === details.Suggest.length - 1)">、</span>
              </span>
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">其他建议：</div>
            <div class="item-right">
              {{ details.SuggestSupplement }}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">备注：</div>
            <div class="item-right">
              {{ details.Memo }}
            </div>
          </div>
        </div>
      </div>
      <div class="multiple" v-if="salesmanList.length">
        <el-tabs v-model="activeName">
          <el-tab-pane
            v-for="item in salesmanList"
            :key="item.ID"
            :label="item.UserName"
            :name="item.UserName"
          />
        </el-tabs>
        <div class="scroll-item" id="anchor6">
          <div v-for="item in details.Contacts" :key="item.ID">
            <sub-title title="项目对接信息"></sub-title>
            <div class="details-table" style="border: none">
              <div class="details-box-item">
                <div class="details-box-item">
                  <div class="item-left">对接方式：</div>
                  <div class="item-right">
                    {{ item.ApproachWay }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">对接开始时间：</div>
                  <div class="item-right">
                    {{ $common.timesToTime(item.ApproachStartDate) }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">对接业务：</div>
                  <div class="item-right">
                    {{ item.ContactBusi }}
                  </div>
                </div>
              </div>
              <div class="details-box-item">
                <div class="details-box-item">
                  <div class="item-left">负责人：</div>
                  <div class="item-right">
                    {{ item.Name }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">电话：</div>
                  <div class="item-right">
                    {{ item.Tel }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">职位：</div>
                  <div class="item-right">
                    {{ item.JobTitle }}
                  </div>
                </div>
              </div>
              <div class="details-box-item">
                <div class="details-box-item">
                  <div class="item-left">经营模式：</div>
                  <div class="item-right">
                    {{ item.SalesWay }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">公司类型：</div>
                  <div class="item-right">
                    {{ item.CompanyCategory }}
                  </div>
                </div>
              </div>
              <div class="details-box-item">
                <div class="item-left">区域：</div>
                <div class="item-right">
                  <span v-for="(a, i) in item.Area" :key="i">
                    {{ a[0] }}{{ a[1]
                    }}<template v-if="!(i === item.Area.length - 1)"
                      >、</template
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll-item" id="anchor7" v-if="TemplateID == '5'">
          <div v-for="item in details.PerformancePriceData" :key="item.ID">
            <div class="price-head">
              <sub-title title="价格配置"></sub-title>
              <el-radio-group size="medium" v-model="item.ProjectTypeCategory">
                <el-radio-button label="Conventional">常规</el-radio-button>
                <el-radio-button label="Unconventional">非常规</el-radio-button>
              </el-radio-group>
            </div>
            <div class="details-table" style="border: none">
              <div class="details-box-item">
                <div class="details-box-item">
                  <div class="item-left">渠道：</div>
                  <div class="item-right">
                    {{ item.WholesalerId | filterWholesaler }}
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">对接人：</div>
                  <div class="item-right">
                    <span v-for="(c, i) in item.DockingPeopleIds" :key="i">
                      <span>{{ c | filterDockingPeople }}</span>
                      <span v-if="!(i === item.DockingPeopleIds.length - 1)"
                        >、</span
                      >
                    </span>
                  </div>
                </div>
                <div class="details-box-item">
                  <div class="item-left">申请说明：</div>
                  <div class="item-right">
                    {{ item.ApplyMemo }}
                  </div>
                </div>
              </div>
            </div>
            <div class="PriceTable">
              <el-table
                class="table-border"
                :data="item.RateConfigurations | filterRate(item)"
                border
                fit
              >
                <el-table-column
                  label="所在区域"
                  prop="RegionName.changeData"
                  align="center"
                  min-width="88"
                />
                <el-table-column label="格式" align="center" min-width="95">
                  <template slot-scope="{ row }">
                    {{ row.FormatTypeCategory.changeData }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="01月~03月"
                  align="center"
                  min-width="400"
                >
                  <el-table-column
                    align="center"
                    label="担保区间"
                    min-width="250"
                  >
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter01"
                        :key="idx"
                      >
                        <span>{{
                          $common.moneyFormat(items.From.changeData, null)
                        }}</span>
                        <span> ~ </span>
                        <span>{{
                          $common.moneyFormat(items.To.changeData, null)
                        }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="费率" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter01"
                        :key="idx"
                        @click="togglePrice('Rate', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template v-if="!items.Rate.isShowStandardPrice">
                          <span>{{
                            (items.Rate.changeData * 100).toFixed(2) + '%'
                          }}</span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.Rate.isChange
                            }"
                          >
                            {{ (items.Rate.originData * 100).toFixed(2) + '%' }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="最低消费" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter01"
                        :key="idx"
                        @click="togglePrice('LowestCharge', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template
                          v-if="!items.LowestCharge.isShowStandardPrice"
                        >
                          <span>
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.changeData,
                                null
                              )
                            }}
                          </span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.originData,
                                null
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  label="03月~06月"
                  align="center"
                  min-width="400"
                >
                  <el-table-column
                    align="center"
                    label="担保区间"
                    min-width="250"
                  >
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter02"
                        :key="idx"
                      >
                        <span>{{
                          $common.moneyFormat(items.From.changeData, null)
                        }}</span>
                        <span> ~ </span>
                        <span>{{
                          $common.moneyFormat(items.To.changeData, null)
                        }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="费率" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter02"
                        :key="idx"
                        @click="togglePrice('Rate', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template v-if="!items.Rate.isShowStandardPrice">
                          <span>{{
                            (items.Rate.changeData * 100).toFixed(2) + '%'
                          }}</span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{ (items.Rate.originData * 100).toFixed(2) + '%' }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="最低消费" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter02"
                        :key="idx"
                        @click="togglePrice('LowestCharge', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template
                          v-if="!items.LowestCharge.isShowStandardPrice"
                        >
                          <span>
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.changeData,
                                null
                              )
                            }}
                          </span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.originData,
                                null
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  label="06月~09月"
                  align="center"
                  min-width="400"
                >
                  <el-table-column
                    align="center"
                    label="担保区间"
                    min-width="250"
                  >
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter03"
                        :key="idx"
                      >
                        <span>{{
                          $common.moneyFormat(items.From.changeData, null)
                        }}</span>
                        <span> ~ </span>
                        <span>{{
                          $common.moneyFormat(items.To.changeData, null)
                        }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="费率" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter03"
                        :key="idx"
                        @click="togglePrice('Rate', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template v-if="!items.Rate.isShowStandardPrice">
                          <span>{{
                            (items.Rate.changeData * 100).toFixed(2) + '%'
                          }}</span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{ (items.Rate.originData * 100).toFixed(2) + '%' }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="最低消费" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter03"
                        :key="idx"
                        @click="togglePrice('LowestCharge', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template
                          v-if="!items.LowestCharge.isShowStandardPrice"
                        >
                          <span>
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.changeData,
                                null
                              )
                            }}
                          </span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.originData,
                                null
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  label="09月~12月"
                  align="center"
                  min-width="400"
                >
                  <el-table-column
                    align="center"
                    label="担保区间"
                    min-width="250"
                  >
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter04"
                        :key="idx"
                      >
                        <span>{{
                          $common.moneyFormat(items.From.changeData, null)
                        }}</span>
                        <span> ~ </span>
                        <span>{{
                          $common.moneyFormat(items.To.changeData, null)
                        }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="费率" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter04"
                        :key="idx"
                        @click="togglePrice('Rate', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template v-if="!items.Rate.isShowStandardPrice">
                          <span>{{
                            (items.Rate.changeData * 100).toFixed(2) + '%'
                          }}</span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{ (items.Rate.originData * 100).toFixed(2) + '%' }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="最低消费" width="120">
                    <template slot-scope="{ row }">
                      <div
                        class="column"
                        v-for="(items, idx) in row.Configuration.Quarter04"
                        :key="idx"
                        @click="togglePrice('LowestCharge', items)"
                        style="cursor: pointer"
                      >
                        <!-- 现在价格 -->
                        <template
                          v-if="!items.LowestCharge.isShowStandardPrice"
                        >
                          <span>
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.changeData,
                                null
                              )
                            }}
                          </span>
                        </template>
                        <!-- 标准价格 -->
                        <template v-else>
                          <span
                            :class="{
                              isChangeBlue: items.LowestCharge.isChange
                            }"
                          >
                            {{
                              $common.moneyFormat(
                                items.LowestCharge.originData,
                                null
                              )
                            }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart
        :details="details"
        :selTab="type"
        :TemplateID="TemplateID"
        @close="$emit('refresh')"
        v-if="JSON.stringify(details) != '{}'"
      ></flow-chart>
    </div>
  </div>
</template>
<script>
import { WorkflowQuery, GetUserChannel, GetDockingPeople } from '@/http/api'
import { fetchSysDicList } from '@/http/dictionary'
import contrast from '../../../utils/contrast'
var that
export default {
  name: 'CustomerProcessDetail',
  components: {},
  props: {
    ID: {
      // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    TemplateID: {
      // 流程ID
      type: Number,
      default: null
    }
  },
  filters: {
    filterRate (val, item) {
      let arr = val.filter(
        key => key.ProjectTypeCategory.changeData == item.ProjectTypeCategory
      )
      return arr
    },
    filterWholesaler (val) {
      let Title = ''
      that.ChannelList.forEach(item => {
        if (item.Id == val) {
          Title = item.Name
        }
      })
      return Title
    },
    filterDockingPeople (val) {
      let Title = ''
      that.DockingPeopleList.forEach(item => {
        if (item.Id == val) {
          Title = item.Name
        }
      })
      return Title
    },
    filterCategory (val) {
      let Title = ''
      that.FormatTypeCategory.forEach(item => {
        if (item.Name == val) {
          Title = item.Title
        }
      })
      return Title
    }
  },
  data () {
    return {
      activeName: '',
      salesmanList: [],
      DataList: [],
      details: {},
      ChannelList: [],
      DockingPeopleList: [],
      FormatTypeCategory: this.$perFormatType
    }
  },
  created () {
    that = this
  },
  watch: {
    ID: {
      handler (val, oldVal) {
        this.salesmanList = []
        this.getDetails()
      },
      immediate: true
    }
  },
  methods: {
    /**
     * @param name 字段名
     * @param Object 点击的对象
     */
    togglePrice (name, items) {
      // if (row.LowestCharge.isChange || row.Rate.isChange) {
      //   this.$set(row, 'isShowStandardPrice', !row.isShowStandardPrice)
      // }
      // 点击手动更改为标准价
      if (items[name].isChange) {
        this.$set(
          items[name],
          'isShowStandardPrice',
          !items[name].isShowStandardPrice
        )
      }
      if (!items[name].isShowStandardPrice) {
        this.$set(items[name], 'isChange', !items[name].isChange)
      }
    },
    getDetails () {
      this.$emit('loading', true)
      WorkflowQuery(
        { workflowId: this.ID, templateId: this.TemplateID },
        'Get'
      ).then(res => {
        const obj = {
          Addrs: JSON.parse(res.Addrs),
          Tels: JSON.parse(res.Tels),
          Qualification: !!res.Qualification
            ? res.Qualification.split(';')
            : '',
          QualificationDesc: res.QualificationDesc.replace(/\n/g, '<br/>'),
          HonorDesc: JSON.parse(res.HonorDesc),
          LatestYearBidProjectDesc: JSON.parse(res.LatestYearBidProjectDesc),
          Suggest: !!res.Suggest ? res.Suggest.split(';') : ''
        }
        res.Contacts.forEach(item => {
          // 处理区域
          item.Area = JSON.parse(item.Area)
          // 处理业务员列表
          if (!item.UserInfo) return // 如果没有UserInfo就不添加避免报错
          this.salesmanList.push({
            UserName: item.UserInfo.Name,
            UserId: item.UserInfo.ID
          })
        })
        if (this.TemplateID == '5') {
          let oldPrice = JSON.parse(res.FieldChangesJson) || []
          res.PerformancePriceData.forEach(key => {
            this.$set(key, 'ProjectTypeCategory', 'Conventional') // 默认选中常规
            // key.RateConfigurations.map(item => {
            //   for (const key in item) {
            //     if (key == 'Month3' || key == 'Month6' || key == 'Month9' || key == 'Month12' || key == 'Month15' || key == 'Month18' || key == 'Month21' || key == 'Month24' || key == 'Month27' || key == 'Month30' || key == 'Month33' || key == 'Month36') {
            //       this.$set(item, 'isShowStandardPrice', false);     // 是否显示标准价
            //       if (item[key] && item[key].Rate) item[key].Rate = Number((item[key].Rate * 100).toFixed(4));
            //     }
            //   }
            // });
            GetUserChannel({ bgUserId: key.UserId }).then(
              res => (this.ChannelList = [...this.ChannelList, ...res])
            ) // 获取当前业务员渠道
            GetDockingPeople({
              bgUserId: key.UserId,
              channelId: key.WholesalerId
            }).then(
              res =>
                (this.DockingPeopleList = [...this.DockingPeopleList, ...res])
            ) // 获取对接人
            key.RateConfigurations = contrast(oldPrice, key.RateConfigurations)
            // 处理业务员列表
            if (!key.UserInfo) return // 如果没有UserInfo就不添加避免报错
            this.salesmanList.push({
              UserName: key.UserInfo.Name,
              UserId: key.UserInfo.ID
            })
          })
        }
        this.salesmanList = this.removeDuplicates(this.salesmanList, 'UserId') // 去重
        this.details = Object.assign(res, obj)
        this.activeName = this.salesmanList[0].UserName
        this.$emit('loading', false)
      })
    },
    removeDuplicates (arr, params) {
      // 数组对象去重方法 arr：需要去重的数组    params：数组内对象的属性名
      let obj = {}
      let peon = arr.reduce((cur, next) => {
        obj[next[params]] ? '' : (obj[next[params]] = true && cur.push(next))
        return cur
      }, [])
      return peon
    }
  }
}
</script>
<style scoped lang="less">
@import './details.less';

.table-border {
  min-width: 1276px;
  margin-top: 8px;
}
.setWidth1 {
  width: 98px !important;
}
.setWidth2 {
  width: 126px !important;
}
.setWidth3 {
  width: 266px !important;
}
.setWidth4 {
  width: 168px !important;
}
.setWidth5 {
  width: 154px !important;
}
.setWidth6 {
  width: 238px !important;
}
.setWidth7 {
  width: 112px !important;
}

.PriceTable {
  ::v-deep .table-border {
    &.el-table--border {
      thead > tr:nth-child(2) {
        th.el-table__cell:nth-child(n) {
          border-bottom-color: #fff !important;
          border-right-color: #fff !important;
        }
      }
      thead > tr > th.el-table__cell:nth-child(n + 3) {
        border-bottom-color: #fff !important;
        border-right-color: #fff !important;
      }
    }

    tbody > tr > td.el-table__cell .cell {
      padding: 0;
    }
    thead > tr > th.el-table__cell:nth-child(3) {
      background: #e5edff !important;
    }
    thead > tr > th.el-table__cell:nth-child(4) {
      background: #fce4d3 !important;
    }
    thead > tr > th.el-table__cell:nth-child(5) {
      background: #e3f2d9 !important;
    }
    thead > tr > th.el-table__cell:nth-child(6) {
      background: #fadade !important;
    }
    thead > tr:nth-child(2) {
      th.el-table__cell:nth-child(n + 1) {
        background: #e5edff !important;
      }
      th.el-table__cell:nth-child(n + 4) {
        background: #fce4d3 !important;
      }
      th.el-table__cell:nth-child(n + 7) {
        background: #e3f2d9 !important;
      }
      th.el-table__cell:nth-child(n + 10) {
        background: #fadade !important;
      }
    }
  }
  // 盒子样式
  ::v-deep .cell {
    height: auto;
    display: block !important;
    .column {
      padding: 8px 0;
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: 0px;
      }
    }
  }
}
</style>
